import axios from "axios";
import Config from "src/config";

// clienteId = cliente do dashboard. O canal (Página) vai sempre em params.canalId —
// diferente do WhatsApp, onde o primeiro segmento da URL é o cliente_id do canal.
const v1_actionMessengerTemplates = (clienteId, params = {}) => {
    const query = new URLSearchParams();
    if (params.canalId) query.set('canalId', params.canalId);
    // Alternativa ao canalId para o chat, que só tem a sessão em mãos
    if (params.sessao) query.set('sessao', params.sessao);
    if (params.status) query.set('status', params.status);
    if (params.search) query.set('search', params.search);
    if (params.page) query.set('page', params.page);
    if (params.limit) query.set('limit', params.limit);

    const queryString = query.toString() ? `?${query.toString()}` : '';

    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates${queryString}`
    });
};

export default v1_actionMessengerTemplates;
